<template>
  <div class="about">
    <div class="container">
      <div class="banner">
        <div class="auto-container">
          <h1>联系</h1>
          <p>
            <a href="/">首页</a>
            <Icon class="arrow" type="ios-arrow-forward" />联系
          </p>
        </div>
      </div>
      <div class="contact-con">
        <div class="icon">
          <Icon type="ios-call-outline" size="100" />
        </div>
        <h4>商务洽谈</h4>
        <p>电话：13816006122</p>
        <p>联系地址：上海市长宁区泉口路17号502室</p>
      </div>
      <!-- <am-map id="map-container" class="map" :init-map-options="options" :visible="true">
      </am-map> -->

      <div id="map-container" class="map"></div>
    </div>
  </div>
</template>
<script>
import contact from "./contact.js";
export default contact;
</script>

<style lang="less" scoped>
@import "./contact.less";
</style>
